/**
 * Hides text visually but keeps it for screen readers ("I ri", "… ju etiketoi"). Pixel strings
 * on purpose: in `sx` a number up to 1 is a fraction, so `width: 1` would be 100% and push the
 * surrounding list sideways.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  border: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const;
